t = require('app/scripts/views/internal/teacup-with-helpers')('popover_move_list')

module.exports = t.renderable ({ organizations, hasEnterprise, enterpriseName }) ->
  t.div '.form-grid', ->

    t.div '.button-link.setting.form-grid-child.form-grid-child-full', ->
      t.span '.label', ->
        t.format 'board'
      t.span '.value.js-board-value'
      t.label ->
        t.format 'board'
      t.select '.js-select-board', ->
        for org in organizations
          t.optgroup { label: org.displayName }, ->
            for board in org.boards
              t.optionSelected board.selected, { value: board.id }, ->
                t.text board.name
                if board.selected
                  t.text ' '
                  t.format 'current'

  if hasEnterprise
    t.p '.quiet', ->
      t.format('list-can-only-be-moved-to-teams-within-org', { enterpriseName })

  t.div '.form-grid', ->

    t.div '.button-link.setting.form-grid-child.form-grid-child-full', ->
      t.span '.label', ->
        t.format 'position'
      t.span '.value.js-pos-value'
      t.label ->
        t.format 'position'
      t.select '.js-select-list-pos'

  t.input '.primary.wide.js-commit-position', { type: 'submit', value: t.l('move') }
  t.p ->
    t.span '.error.hide.js-list-limit-exceeded', ->
      t.format 'too many lists'
